import React, { useContext } from 'react';
import SteppedModal from 'components/SteppedModal';
import { SocialShareModalContextType } from './types';
import useSocialShareAuth from './useSocialShareAuth';
import useSocialShareDescription from './useSocialShareDescription';
import useSocialShareModalSteps from './useSocialShareModalSteps';
import useSocialShareSchedule from './useSocialShareSchedule';
import useSocialShareSelectedAccount from './useSocialShareSelectedAccount';

const SocialShareModalContext = React.createContext<
  SocialShareModalContextType | undefined
>(undefined);

export type SocialShareModalProviderProps = {
  modalRef?: React.RefObject<SteppedModal>;
  children: React.ReactNode;
};

export const SocialShareModalProvider: React.FC<SocialShareModalProviderProps> = ({
  modalRef,
  children,
}) => {
  const socialShareDescription = useSocialShareDescription();
  const socialShareAuth = useSocialShareAuth({
    onAuthSuccess: socialShareDescription.resetDescription,
  });
  const selectedAccount = useSocialShareSelectedAccount();
  const socialShareSchedule = useSocialShareSchedule();
  const socialShareModalSteps = useSocialShareModalSteps({ modalRef });

  return (
    <SocialShareModalContext.Provider
      value={{
        modalRef,
        ...socialShareAuth,
        ...selectedAccount,
        ...socialShareSchedule,
        ...socialShareDescription,
        ...socialShareModalSteps,
      }}
    >
      {children}
    </SocialShareModalContext.Provider>
  );
};

export function useSocialShareModal() {
  const context = useContext(SocialShareModalContext);

  if (context === undefined) {
    throw new Error(
      'useSocialShareModal must be used within SocialShareModalProvider',
    );
  }

  return context;
}
